import { Box, Container, LoadingOverlay, Paper, Title } from '@mantine/core'
import Image from 'next/image'
import { useRouter } from 'next/router'

import { Redirect, ViewDenied } from '@/components/commons'
import { SignupForm } from '@/containers/forms'
import { useFetch } from '@/lib/hooks'
import { getUrlString } from '@/lib/utils'
import { useAuth } from '@/providers/AuthProvider'
import { Site as SiteType } from '@/types'

interface Data {
  site?: SiteType
}

interface Props {
  initialData?: Data
}

export default function SignupView({ initialData }: Props) {
  // Hooks
  const router = useRouter()
  const { isAuthenticated, isValidating } = useAuth() || {}

  // Constants
  const { site, callbackUrl, channel } = router.query
  const siteSlug = getUrlString(site)
  const callbackUrlSlug = getUrlString(callbackUrl)
  const channelSlug = getUrlString(channel)

  // Fetch
  const { data: siteData } = useFetch([siteSlug ? `/${siteSlug}/` : null], {
    fallbackData: initialData?.site
  })

  // Guards
  if (!siteData?.isSignupAllowed) return <Redirect url="/404" replace />
  if (isAuthenticated) return <Redirect url={callbackUrlSlug || '/'} variant="" />
  if (siteData?.privacy === 'private') return <ViewDenied />

  return (
    <Container size="xs" px="xs" py="lg" sx={{ alignSelf: 'center', width: '100%' }}>
      <LoadingOverlay visible={!!isAuthenticated || !!isValidating} />

      <Box sx={{ textAlign: 'center' }}>
        <Image alt={siteData?.title} src={siteData?.logo} width={80} height={80} />
        <Title mb="lg">{siteData?.title}</Title>
      </Box>
      <Paper radius="md" p="xl" withBorder>
        <Title size="sm" mb="sm">
          Responsável financeiro
        </Title>

        <SignupForm.Signup channel={channelSlug as string} />
      </Paper>
    </Container>
  )
}
